import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/identity_analytics.py
export const IDENTITY_ANALYTICS_ACTIONS = {
  OPENED_MODAL_EFFECTIVE_PERMISSIONS: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'opened_modal_effective_permissions',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_MODAL_EFFECTIVE_PERMISSIONS: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'closed_modal_effective_permissions',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_DATA_ACCESS_ROW_OVERFLOW_MENU: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'opened_data_access_row_overflow_menu',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_PARTY_BASIC_SETTINGS_TAB: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'opened_party_basic_settings_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_PARTY_DATA_ACCESS_TAB: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'opened_party_data_access_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_PARTY_SETTINGS: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'clicked_party_settings',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_USER_PROFILE_PAGE: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'viewed_user_profile_page',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_USER_SUSPENSION: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'updated_user_suspension',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INITIATED_AUDIT_LOG_EXPORT: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'initiated_audit_log_export',
    actionCategory: ACTION_CATEGORY.READ,
  },
  REVOKED_WAREHOUSE_CREDENTIAL: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'revoked_warehouse_credential',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REVOKED_API_KEY: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'revoked_api_key',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_USER_FIELD: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'updated_user_field',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  FAILED_USER_FIELD_EDIT: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'failed_user_field_edit',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DENIED_DELEGATED_AUTH_CONSENT: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'denied_delegated_auth_consent',
    actionCategory: ACTION_CATEGORY.READ,
  },
  TEST_SAML_LINK_EXPIRED: {
    module: ANALYTICS_MODULE.IDENTITY,
    action: 'test_saml_link_expired',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
